import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DOCUMENT_DETAILS_FEATURE_KEY, DocumentDetailsState } from './document-details.reducer';

export const selectDocumentDetailsState = createFeatureSelector<DocumentDetailsState>(DOCUMENT_DETAILS_FEATURE_KEY);

export const selectDocumentDetails = createSelector(selectDocumentDetailsState, (state) => state.documentDetails);

export const selectDocumentDetailsLoaded = createSelector(selectDocumentDetailsState, (state) => state.loaded);

export const selectDocumentDetailsError = createSelector(selectDocumentDetailsState, (state) => state.error);
